import React from 'react';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import { tooltipZIndexModifiers } from '~/constants/reactstrap';
import { routes } from '~/helpers/routes';

interface TokenLinksOnNotesModalProps {
  token: string;
  noteId: Number;
}

const TokenLinksOnNotesModal: React.FC<TokenLinksOnNotesModalProps> = ({ token, noteId }) => {
  const tokenString = `${token.slice(0, 8)}...`;
  const id = `evaluation-link-${token}-${noteId}`;

  return (
    <>
      <a
        className="secondary"
        href={routes.evaluations.detail({ evaluationToken: token })}
        rel="noreferrer"
        target="_blank"
        id={id}
      >
        {tokenString}
      </a>
      <Tooltip
        target={id}
        placement="right"
        delay={0}
        modifiers={tooltipZIndexModifiers}
      >
        {token}
      </Tooltip>
    </>
  );
};

export default TokenLinksOnNotesModal;
